import Image from "next/image";
import Link from "next/link";

interface NoProductFoundProps {
  title?: string;
  description?: string;
  className?: string;
  buttonText?: string;
  buttonLink?: string;
}

const NoProductFound = ({
  title = "No Results Found",
  description = "No matches found. Adjust or reset filters for more options.",
  className = "",
  buttonText,
  buttonLink = "/",
}: NoProductFoundProps) => {
  return (
    <>
    <div className={`col-span-full text-center text-gray-500 pt-[32px] pb-[36px] ${className}`}>
      <div className="relative w-[73px] h-[73px] rounded-full bg-[#F3F4F6] mx-auto mb-4">
        <Image
          src={`${process.env.NEXT_PUBLIC_CDN_STATIC_URL}lib-icon/search.svg`}
          alt="Previous"
          title="Previous"
          width={36}
          height={36}
          className="absolute left-4 top-1/2 -translate-y-1/2 text-[#99A1AF] w-[36px] h-[36px] z-10 invert-[60%] brightness-[70%]"
        />
      </div>

      <p className="font-roboto font-normal text-[24px] leading-[32px] text-center text-[#0A0A0A] mb-[16px]">
        {title}
      </p>

      <p className="font-roboto font-normal text-[16px] leading-[24px] text-center text-[#717182] mb-6">
        {description}
      </p>

      {buttonText && (
        <Link
          href={buttonLink}
          className="inline-flex items-center justify-center px-6 py-3 rounded-md bg-[#008C8A] text-white text-[14px] font-medium hover:bg-[#007371] transition"
        >
          {buttonText}
        </Link>
      )}
    </div>
    </>
  );
};

export default NoProductFound;